<template>
  <div
    :class="{
      [$style.container]: true,
      [$style.disabled]: disabled,
      [$style.interactivePill]: interactive,
      [$style.interactivePillActive]: active,
    }"
    @click="handleClick"
  >
    <component
      :is="iconComponent"
      v-if="iconComponent"
      :class="$style.icon"
    />
    <span :class="$style.text">
      {{ text }}
    </span>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" v-if="showDeleteButton" :class="$style.deleteButton" v-bind:svg-inline="''" @click.prevent="handleDeleteButtonClick" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 10A5 5 0 115 0a5 5 0 010 10z" fill="#414C55"/><path d="M6.854 3.146a.5.5 0 010 .708L5.707 5l1.147 1.146a.5.5 0 11-.708.708L5 5.707 3.854 6.854a.5.5 0 11-.708-.708L4.293 5 3.146 3.854a.5.5 0 11.708-.708L5 4.293l1.146-1.147a.5.5 0 01.708 0z" fill="#fff"/></svg>
  </div>
</template>
<script>
/**
 * @todo Modify component to use an SVG icon instead of the jc-actions-x class and an <i> element.
 */
export default {
  name: 'Pill',

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    handleDeleteButtonClick: {
      type: Function,
      default: () => {},
    },
    iconComponent: {
      type: Object,
      default: null,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>
<style module>
.interactivePill {
  cursor: pointer;
  margin-right: 10px;
}

.interactivePill:hover {
  background-color: var(--jcPrimary);
}

.container {
  background-color: var(--jcGrey300);
  border-radius: 4px;
  display: inline-block;
  padding: 1px 9px;
  white-space: nowrap;
}

.container:not(:last-child) {
  margin-right: 4px;
}

.interactivePillActive,
.interactivePillActive:hover {
  background-color: var(--jcPrimary);
}

.disabled {
  cursor: default;
  opacity: 0.5;
}

.disabled:hover {
  background-color: var(--jcGrey300);
}

.text {
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  padding: 0 4px 0 2px;
}

.deleteButton {
  cursor: pointer;
  font-size: 11px;
  position: relative;
  vertical-align: -1px;
  width: 10px;
}

.icon {
  fill: currentColor;
  height: 0.6em;
  vertical-align: middle;
  width: 0.6em;
}
</style>
